import React, {useEffect, useState} from 'react';
import $ from "jquery";
import moment from "moment";
import {
    GET_COL_AGGREGATE_DATA,
    GET_COLLECTION_AGGREGATE_DATA
} from "../../../api";
import cogoToast from "cogo-toast";
import {getAgent} from "../../../api/app";
import {capitalize} from "../../../utils/capitalize";
import {agentQuery, membershipQuery} from "../../../query/aggregation";
import DateRangePicker from "../../../components/common/DatePicker";

const searchableFields = [
    { field: 'first_name', isNumeric: false },
    { field: 'last_name', isNumeric: false },
    { field: 'full_name', isNumeric: false },
    { field: 'contact_number', isNumeric: false },
    { field: 'agent.name', isNumeric: true },
    { field: 'agent.username', isNumeric: true },
    { field: 'id_number', isNumeric: false }
];

let currentDateRange = null;
let filter = {};

const AgentData = (props) => {

    const token = localStorage.getItem('jwtToken');

    const id = props.match.params.id;
    const [loading, setLoading] = useState(true);
    const [userData, setUserData] = useState(null);
    const [currDateRange, setCurrDateRange] = useState(null);
    const [selectedDate, setSelectedDate] = useState(false);
    const [reset, setReset] = useState(new Date().getTime());
    const [datatable] = useState({
        membership: false,
        agent: false,
        report: false
    });

    useEffect(() => {
        getAgent(id).then((response) => {
            if (!response.error) {
                setUserData(response.payload.agent);
                setLoading(false);
            }
        });
    }, [reset]);

    const handleDateRangeSelect = (range) => {
        const formattedStartDate = $.datepicker.formatDate('dd/mm/yy', range.startDate);
        const formattedEndDate = $.datepicker.formatDate('dd/mm/yy', range.endDate);

        currentDateRange = {
            start: moment(formattedStartDate, 'DD/MM/YYYY').format("YYYY/MM/DD 00:00:00"),
            end: moment(formattedEndDate, 'DD/MM/YYYY').format("YYYY/MM/DD 23:59:59")
        };

        setCurrDateRange({
            start: moment(formattedStartDate, 'DD/MM/YYYY').format("YYYY/MM/DD 00:00:00"),
            end: moment(formattedEndDate, 'DD/MM/YYYY').format("YYYY/MM/DD 23:59:59")
        });

        filter = Object.assign(filter, {
            "date.str": {
                $gte: currentDateRange.start,
                $lte: currentDateRange.end,
            }
        });

        setSelectedDate(true);

        $('#membership-dt').DataTable().ajax.reload();
    };

    const membershipDatatable = () => {
        if(datatable.membership) return false;
        datatable.membership = true;
        const table = $('#membership-dt').DataTable({
            responsive: true,
            "language": {
                "processing": '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Membership Report</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function(data, callback) {
                const searchTerm = ($('.dataTables_filter input').val() || '').trim();

                const baseFilter = {
                    $match: {
                        doc: userData._id,
                        ...filter
                    }
                };

                $.ajax(GET_COL_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    contentType: 'application/json',
                    data: JSON.stringify({
                        query: searchTerm,
                        collection: "membership",
                        filter: membershipQuery(data.start, data.length, baseFilter, searchTerm, searchableFields)
                    }),
                    success: function (res) {
                        let array = [];
                        res.data[0].results.map((data) => {
                            array.push({raw: data})
                        });

                        callback({
                            recordsTotal: res.data[0].totalCount[0] ? res.data[0].totalCount[0].total : 0,
                            recordsFiltered: res.data[0].totalCount[0] ? res.data[0].totalCount[0].total : 0,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {
                    className: 'dt-control',
                    orderable: false,
                    data: null,
                    defaultContent: '',
                },
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function () {
                        return null;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return capitalize(`${data.first_name} ${data.last_name}`);
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return data.id_number;
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return data.gender === "n/a" ? "N/A" : capitalize(data.gender);
                    },
                    "targets": 3
                },
                {
                    "render": function (data) {
                        return data.category === "n/a" ? "N/A" : capitalize(data.category);
                    },
                    "targets": 4
                },
                {
                    "render": function (data) {
                        return moment(data.createdAt).format("Do MMM, YYYY HH:mm");
                    },
                    "targets": 5
                }
            ]
        });

        $('#membership-dt tbody').on('click', 'td.dt-control', function () {
            let tr = $(this).closest('tr');
            let row = table.row(tr);

            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
            } else {
                // Open this row
                row.child(format(row.data())).show();
                tr.addClass('shown');
            }
        });

        function format(d) {
            // `d` is the original data object for the row
            return (
                '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">' +
                '<tr>' +
                '<td>Age Group:</td>' +
                '<td class="text-capitalize">' +
                d?.raw.age_group +
                '<tr>' +
                '<td>Contact Number:</td>' +
                '<td>' +
                d?.raw.contact_number +
                '<tr>' +
                '<td>PCT Level:</td>' +
                '<td class="text-capitalize">' +
                d?.raw.position +
                '<tr>' +
                '<td>Polling Station:</td>' +
                '<td>' +
                d?.raw.polling_station.name +
                '<tr>' +
                '<td>Ward:</td>' +
                '<td>' +
                d?.raw.admin_level.provincial.name +
                '<tr>' +
                '<tr>' +
                '<td>Registered Voter Card:</td>' +
                '<td>' +
                `${d?.raw?.voter_card ? capitalize(d?.raw.voter_card) : "Not Data"}` +
                '<tr>' +
                '<tr>' +
                '<td>Support Level:</td>' +
                '<td>' +
                `${d?.raw?.support_level ? capitalize(d?.raw.support_level) : "Not Data"}` +
                '<tr>' +
                '<td>Documents:</td>' +
                '<td class="text-capitalize">' +
                `${d?.raw?.documents?.length > 0 ? `<nav class="nav nav-icon-only"><a target="_blank" href=${d?.raw?.documents[0]?.uri} class="nav-link edit_user"><i class="fa fa-eye"></i> View Voter Card</a></nav>` : "No document"}` +
                '<tr>' +
                '<td>Added By:</td>' +
                '<td class="text-capitalize text-primary">' +
                d?.raw.agent.name +
                '</table>'
            );
        }
    }

    const agentDatatable = () => {
        if(datatable.agent) return false;
        datatable.agent = true;

        let table = $('#agent-dt').DataTable({
            language: {
                searchPlaceholder: 'Search name',
                sSearch: '',
                lengthMenu: '_MENU_ items/page',
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Agent Data</p>'
            },
            processing: true,
            serverSide: true,
            responsive: true,
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            pageLength: 10,
            ajax: (data, callback) => {
                const term = (data.search.value || '').trim();
                const searchMatch = term ? {
                    $match: {
                        $or: [
                            { name: { $regex: term, $options: 'i' } },
                            { username: { $regex: term, $options: 'i' } },
                            { mobile_number: { $regex: term, $options: 'i' } },
                            { id_number: { $regex: term, $options: 'i' } }
                        ]
                    }
                } : null;

                const baseFilter = {
                    $match: {
                        "meta.doc": userData._id
                    }
                };

                $.ajax(GET_COL_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    contentType: 'application/json',
                    data: JSON.stringify({
                        query: $('.dataTables_filter input').val(),
                        collection: "agent",
                        filter: agentQuery(data.start, data.length, baseFilter, searchMatch),
                        pageSize: data.start,
                        format: 'json',
                        sort: {_id: -1},
                        pageIndex: (data.length + data.start) / data.length
                    }),
                    success: function (res) {
                        let records = res.data[0] || { results: [], totalCount: [] };
                        let total = records.totalCount.length > 0 ? records.totalCount[0].count : 0;

                        let array = records.results.map(row => ({ raw: row }));

                        callback({
                            recordsTotal: total,
                            recordsFiltered: total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {
                    className: 'dt-control',
                    orderable: false,
                    data: null,
                    defaultContent: '',
                },
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function () {
                        return null;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return data.name;
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return data.username;
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return capitalize(data?.position || "Not Set");
                    },
                    "targets": 3
                },
                {
                    "render": function (data) {
                        return {
                            true : `<span class="badge badge-success tx-white">Active</span>`,
                            false : `<span class="badge badge-danger tx-white">Inactive</span>`
                        }[data.active];
                    },
                    "targets": 4
                },
                {
                    "render": function () {
                        return `<nav class="nav nav-icon-only"><a href="#" class="nav-link view_agent"><i class="fa fa-eye"></i> View</a> <a href="#" class="nav-link edit_agent"><i class="fa fa-pencil"></i> Edit</a> <a href="#" class="nav-link delete_agent"><i class="fa fa-trash-alt"></i> Delete</a></nav>`
                    },
                    "targets": 5
                }
            ]
        });

        $('#agent-dt tbody').on('click', 'td.dt-control', function () {
            let tr = $(this).closest('tr');
            let row = table.row(tr);

            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
            } else {
                // Open this row
                row.child(format(row.data())).show();
                tr.addClass('shown');
            }
        });

        function format(d) {
            const mappedItems = (d?.raw?.admin_level || [])
                .filter(level =>
                    Array.isArray(level.data) &&
                    level.data.some(entry => entry?.name?.trim())
                )
                .map(level => {
                    const names = level.data
                        .filter(entry => entry?.name?.trim())   // ignore empties
                        .map(entry => entry.name.trim())
                        .join(', ');

                    return `
                        <tr>
                          <td class="text-capitalize">${level.model}:</td>
                          <td>${names}</td>
                        </tr>`;
                })
                .join('');

            return `
                    <table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">
                      <tr>
                        <td>NRC Number:</td>
                        <td>${d?.raw?.id_number ?? 'Not Set'}</td>
                      </tr>
                      <tr>
                        <td>Contact Number:</td>
                        <td>${d?.raw?.mobile_number ?? 'Not Set'}</td>
                      </tr>
                      ${mappedItems}
                      <tr>
                        <td>Created At:</td>
                        <td class="text-capitalize">
                          ${moment(d?.raw?.createdAt).format('Do MMM, YYYY HH:mm')}
                        </td>
                      </tr>
                      <tr>
                        <td>Added By:</td>
                        <td class="text-primary">${d?.raw?.meta?.doc?.name ?? 'Not Set'}</td>
                      </tr>
                      <tr>
                      <tr>
                        <td>Device Info:</td>
                        <td>${d.raw?.device?.mobile?.brand_name ? capitalize(d.raw?.device.mobile.brand_name)+', '+d.raw?.device.mobile.model +', version: '+d.raw?.device.mobile.version : "Unregistered"}</td>
                      </tr>
                      <tr>
                    </table>`;
        }
    }

    const reportDatatable = () => {
        if(datatable.report) return false;
        datatable.report = true;
        let table = $('#report-dt').DataTable({
            responsive: true,
            language: {
                searchPlaceholder: 'Search name',
                sSearch: '',
                lengthMenu: '_MENU_ items/page',
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Report Data</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function (data, callback) {
                $.ajax(GET_COLLECTION_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        collection: "Report",
                        searchableFields: [
                            { field: 'description', isNumeric: false }
                        ],
                        filter: {
                            doc: userData._id
                        },
                        pageSize: data.start,
                        populate: [
                            {
                                path: "doc",
                                model: "agent"
                            }
                        ],
                        format: 'json',
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success: function (res) {
                        let array = [];
                        res.data.map((data) => {
                            array.push({raw: data})
                        });
                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {
                    className: 'dt-control',
                    orderable: false,
                    data: null,
                    defaultContent: '',
                },
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function () {
                        return null;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return data.doc?.name ? capitalize(data.doc.name) : "No agent Found."
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return {
                            unresolved : `<span class="badge badge-info tx-white">Unresolved</span>`,
                            resolved : `<span class="badge badge-success tx-white">Resolved</span>`,
                            rejected : `<span class="badge badge-danger tx-white">Rejected</span>`
                        }[data.status];
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return moment(data.createdAt).format("Do MMM, YYYY")
                    },
                    "targets": 3
                },
                {
                    "render": function () {
                        return "No Action"
                        return `<nav class="nav nav-icon-only"><a href="#" class="nav-link edit_company"><i class="fa fa-trash"></i> Delete</a></nav>`
                    },
                    "targets": 4
                }
            ]
        });

        $('#report-dt tbody').on('click', 'td.dt-control', function () {
            let tr = $(this).closest('tr');
            let row = table.row(tr);

            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
            } else {
                // Open this row
                row.child(format(row.data())).show();
                tr.addClass('shown');
            }
        });

        function format(d) {
            // `d` is the original data object for the row
            return (
                '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">' +
                '<tr>' +
                '<td>Description:</td>' +
                '<td class="text-capitalize">' +
                d?.raw.description +
                '<tr>' +
                '<td>Position:</td>' +
                '<td class="text-capitalize">' +
                `${d?.raw.doc.position || "Not Set"}` +
                '</table>'
            );
        }
    }

    const handleFilterSelect = (value, name) => {
        filter = Object.assign(filter, {
            "voter_card": value === "registered" ? value : "n/a"
        });

        $("#tx-filter-level").text(name);
        $('#membership-dt').DataTable().ajax.reload();
    }

    if(!loading) {
        return (
            <div className="content-body">
                <div className="container-fluid pd-x-0">
                    <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                        <div>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                    <li className="breadcrumb-item"><a href="#">Menu</a></li>
                                    <li className="breadcrumb-item"><a href="#">Customer</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">Details</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-none d-md-block">
                            {userData.active ? <span className="badge badge-success tx-white">Active</span> :
                                <span className="badge badge-danger tx-white">Inactive</span>}
                        </div>
                    </div>

                    <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                        <div className="media">
                            <div className="wd-100 ht-100 bg-ui-04 rounded d-flex align-items-center justify-content-center bg-white">
                                <span className="link-03 lh-0 text-center"><i style={{fontSize: 50}} className="icon ion-md-camera"></i><p className="text-center tx-color-03 mt-2 tx-13">No Photo</p></span>
                            </div>
                            <div className="media-body pd-l-25 my-auto">
                                <h5 className="mg-b-5 text-capitalize">{userData.name}</h5>
                                <p className="mg-b-3 text-capitalize">
                                    <span className="tx-medium tx-color-02 text-capitalize">{userData.username}</span><br/>
                                    Agent
                                </p>
                                <span className="d-block tx-13 tx-color-03">{userData.mobile_number}</span>
                            </div>
                        </div>
                    </div>

                    <div className="row row-xs">
                        <div className="col-md-12 mg-t-10">
                            <div className="nav-wrapper mg-b-20 tx-13">
                                <div>
                                    <ul id="nav_basic" className="nav nav-line nav-fill tx-medium">
                                        <li className="nav-item"><a href="#basic " className="nav-link active" data-toggle="tab"><i className="ion-md-information-circle"/> Info</a></li>
                                        <li className="nav-item"><a href="#membership" className="nav-link" data-toggle="tab" onClick={membershipDatatable.bind()}><i className="ion-md-person"/> Membership</a></li>
                                        <li className="nav-item"><a href="#agent" className="nav-link" data-toggle="tab" onClick={agentDatatable.bind()}><i className="ion-md-person-add"/> Agent</a></li>
                                        <li className="nav-item"><a href="#report" className="nav-link" data-toggle="tab" onClick={reportDatatable.bind()}><i className="ion-md-chatboxes"/> Report</a></li>
                                    </ul>
                                </div>
                            </div>

                            <div className="tab-content">
                                <div id="basic" className="tab-pane fade active show">
                                    <div className="row row-sm">
                                        <div className="col-md-12">
                                            <p><strong>Mobile #:</strong> {userData.mobile_number}</p>
                                            <p><strong>Username:</strong> {userData.username}</p>
                                            <p className="text-capitalize"><strong>Position:</strong> {userData?.position || "Field Missing"}</p>
                                            <p className="d-flex"><strong>Voter Card:</strong> {userData.documents.length > 0 ? <nav className="nav nav-icon-only ml-1"><a target="_blank" href={userData.documents[0].uri} className="nav-link"><i className="fa fa-eye"></i> View Document</a></nav> : <span className="ml-1">No Voter Card</span>}</p>
                                            <p><strong>NRC Number:</strong> {userData.id_number}</p>
                                            <p className="text-capitalize"><strong>Device: </strong>{userData.device?.mobile.brand ? `${userData.device?.mobile.brand}, ${capitalize(userData.device.mobile.model) + `, OS Version ` + capitalize(userData.device.mobile.version)}` : "Unregistered"}</p>
                                            <p><strong>Date Created:</strong> {moment(userData.createdAt).format("Do MMM, YYYY")}</p>
                                        </div>
                                    </div>
                                </div>

                                <div id="membership" className="tab-pane fade">
                                    <div className="row row-sm">
                                        <div className="col-md-12">
                                            <div className="card">
                                                <div className="card-header d-flex align-items-center justify-content-between">
                                                    <h6 className="mg-b-0">Membership List</h6>
                                                    <div className="d-flex tx-18">

                                                        <div className="tx-12 tx-color-03 align-items-center d-none d-sm-flex mg-r-10">
                                                            <div className="dropdown mr-2">
                                                                <a href="javascript:void(0)" className="link-01 tx-spacing-1 tx-rubik d-flex align-items-center dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span id="tx-filter-level">Filter By</span></a>
                                                                <div className="dropdown-menu" aria-labelledby="dropdownSelectButton">
                                                                    <a className="dropdown-item" href="javascript:void(0)" onClick={handleFilterSelect.bind(null, "n/a", "Registration")}>Registration</a>
                                                                    <a className="dropdown-item" href="javascript:void(0)" onClick={handleFilterSelect.bind(null, "registered", "Voter Card")}>Voter Card</a>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="tx-12 tx-color-03 align-items-center d-none d-sm-flex mg-r-15">
                                                            <a href="javascript:void(0)" className="link-01 tx-spacing-1 tx-rubik d-flex align-items-center" onClick={() => $(`#dateRangePicker`).datepicker('show')}>
                                                                <DateRangePicker id="dateRangePicker" onDateRangeSelect={handleDateRangeSelect}/>
                                                                {selectedDate ?
                                                                    <div>
                                                                        <span id="start_date">{moment(currentDateRange?.start).format('DD/MM/YYYY')}</span>
                                                                        <span className="mg-x-10">to</span>
                                                                        <span id="end_date">{moment(currentDateRange?.end).format('DD/MM/YYYY')}</span>
                                                                    </div> : <span>Select Date Range</span>}
                                                                <ion-icon name="chevron-down-outline" aria-label="chevron down outline" role="img" className="md hydrated"></ion-icon>
                                                            </a>
                                                        </div>
                                                        <a href="#" onClick={(e) => {
                                                            setSelectedDate(false);
                                                            setCurrDateRange(null);
                                                            currentDateRange = null;
                                                            filter = {};
                                                            $("#tx-filter-level").text("Filter By");
                                                            e.preventDefault(); $('#membership-dt').DataTable().ajax.reload()}
                                                        } className="link-03 lh-0"><i className="icon ion-md-refresh"></i></a>
                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    <table id="membership-dt" className="table" style={{width: "100%"}}>
                                                        <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th className="wd-20p">Name</th>
                                                            <th className="wd-20p">ID Number</th>
                                                            <th className="wd-20p">Gender</th>
                                                            <th className="wd-20p">Category</th>
                                                            <th className="wd-20p">Date</th>
                                                        </tr>
                                                        </thead>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div id="agent" className="tab-pane fade">
                                    <div className="row row-sm">
                                        <div className="col-md-12">
                                            <div className="card">
                                                <div className="card-header d-flex align-items-center justify-content-between">
                                                    <h6 className="mg-b-0">Agent</h6>
                                                    <div className="d-flex tx-18">
                                                        <a href="#" onClick={(e) => {e.preventDefault(); $('#agent-dt').DataTable().ajax.reload()}} className="link-03 lh-0"><i className="icon ion-md-refresh"></i></a>
                                                    </div>
                                                </div>
                                                <div className="card-body table-responsive">
                                                    <table id="agent-dt" className="table" width={"100%"}>
                                                        <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th className="wd-20p">Name</th>
                                                            <th className="wd-20p">Username</th>
                                                            <th className="wd-20p">Position</th>
                                                            <th className="wd-20p">Active</th>
                                                            <th className="wd-20p">Actions</th>
                                                        </tr>
                                                        </thead>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div id="report" className="tab-pane fade">
                                    <div className="row row-sm">
                                        <div className="col-md-12">
                                            <div className="card">
                                                <div className="card-header d-flex align-items-center justify-content-between">
                                                    <h6 className="mg-b-0">Report</h6>
                                                    <div className="d-flex tx-18">
                                                        <a href="javascript:void(0)" className="link-03 lh-0 mg-l-10" onClick={() => $('#report-dt').DataTable().ajax.reload()}><i className="icon ion-md-refresh"></i></a>
                                                    </div>
                                                </div>
                                                <div className="card-body table-responsive">
                                                    <table id="report-dt" className="table" style={{width: "100%"}}>
                                                        <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th className="wd-25p">Name</th>
                                                            <th className="wd-25p">Status</th>
                                                            <th className="wd-25p">Date</th>
                                                            <th className="wd-25p">Actions</th>
                                                        </tr>
                                                        </thead>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="modalConfirm" tabIndex="-1" role="dialog"
                         aria-labelledby="confirmation" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                            <div className="modal-content tx-14">
                                <div className="modal-header">
                                    <h6 className="modal-title" id="exampleModalLabel6">Delete Confirm?</h6>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <p className="mg-b-0 data-message">Empty</p>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" id="delete-data" className="btn btn-success btn-block">Yes,
                                        Delete
                                    </button>
                                    <button type="button" className="btn btn-danger btn-block mt-0"
                                            data-dismiss="modal">Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="content-body">
            <div className="container d-flex justify-content-center ht-100p">
                <div className="d-flex flex-column align-items-center justify-content-center">
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                    <p className="mg-t-10">Collecting Data</p>
                </div>
            </div>
        </div>
    )
};

export default AgentData;
